"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectTypOdmeny = void 0;
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var useCiselnik_1 = __importDefault(require("../../../hooks/useCiselnik"));
var components_1 = require("../components");
var Label_1 = __importDefault(require("../components/Label"));
var Dropdown_1 = __importDefault(require("../inputs/Dropdown"));
var StyledDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  row-gap: 6px;\n"], ["\n  display: grid;\n  row-gap: 6px;\n"])));
var SelectTypOdmeny = function (_a) {
    var name = _a.name, label = _a.label, readOnly = _a.readOnly, onChange = _a.onChange;
    var _b = formik_1.useField(name), field = _b[0], meta = _b[1], helpers = _b[2];
    var _c = useCiselnik_1.default('typyOdmeny'), data = _c.data, loading = _c.loading, error = _c.error;
    if (error) {
        return react_1.default.createElement(react_1.default.Fragment, null, error);
    }
    if (loading) {
        return react_1.default.createElement(react_1.default.Fragment, null, "na\u010D\u00EDt\u00E1n\u00ED");
    }
    var loadOptions = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (data) {
                return [2 /*return*/, data.map(function (typ) { return ({ value: typ.id, label: typ.nazev }); })];
            }
            return [2 /*return*/, []];
        });
    }); };
    var handleChange = function (val) {
        if (onChange)
            onChange(val);
        helpers.setValue(val);
    };
    return (react_1.default.createElement(StyledDiv, null,
        label && react_1.default.createElement(Label_1.default, { htmlFor: name }, label),
        react_1.default.createElement(Dropdown_1.default, { hasError: !!meta.error, placeholder: "Vyberte ze seznamu", name: "idTypOdmeny", value: field.value, onChange: function (v) { return handleChange(v); }, loadOptions: function () { return Promise.resolve(loadOptions()); }, inputId: name, disabled: readOnly, readOnly: readOnly, size: "md" })));
};
exports.SelectTypOdmeny = SelectTypOdmeny;
exports.default = (function (_a) {
    var props = __rest(_a, []);
    return (react_1.default.createElement(components_1.Field, null,
        react_1.default.createElement(exports.SelectTypOdmeny, __assign({}, props))));
});
var templateObject_1;
